import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import MitoIndexCard from '../twin/MitoIndexCard';
import MitoHistoryChart from '../twin/MitoHistoryChart';
import { RangeSelector, useTimeRange } from './TimeRange';

// The Mito tab, laid out like every other Data tab: the shared range control at
// the top, then the content. The range is owned here rather than inside the
// chart so it sits in the same place, uses the same set (1D…All, Custom), and
// shares the same remembered choice as Sleep, Heart Rate and the rest — pick 3M
// on one tab and you're on 3M here too.
//
// The range deliberately doesn't touch the card above it: that one is today's
// reading and its breakdown, which is a "where am I right now" question. Only
// the history answers "and is that moving".

const MitoDataView = () => {
  const { inRange, selectorProps } = useTimeRange();

  return (
    <div className="space-y-6">
      <RangeSelector {...selectorProps} />

      <MitoIndexCard />

      <Card>
        <CardHeader>
          <CardTitle>Over time</CardTitle>
          <p className="text-sm text-fg-2">
            The index, and the readouts it's built from.
          </p>
        </CardHeader>
        <CardContent>
          <MitoHistoryChart inRange={inRange} />
        </CardContent>
      </Card>
    </div>
  );
};

export default MitoDataView;
